import React, { FC } from 'react';

import image from '../../assets/img/logos/paypal.jpg';

const PaypalLogo: FC = () => {
  return <img src={image} alt="Paypal" width={75} />;
};

export default PaypalLogo;
